import { Checkbox, Modal, ModalClose, ModalDialog } from '@mui/joy';

import { useState } from 'react';

import { Button } from '@/design-system';

export const ConfirmationModal = ({
  isConfirmationModalOpen,
  setIsConfirmationModalOpen,
  setDontShowConfirmationAgain,
}: {
  isConfirmationModalOpen: (() => void) | null;
  setIsConfirmationModalOpen: (value: (() => void) | null) => void;
  setDontShowConfirmationAgain: (value: boolean) => void;
}) => {
  const [isDontShowAgainChecked, setIsDontShowAgainChecked] = useState(false);
  return (
    <Modal
      open={isConfirmationModalOpen != null}
      onClose={() => setIsConfirmationModalOpen(null)}
    >
      <ModalDialog>
        <ModalClose />
        <div className="flex max-w-[500px] flex-col gap-5">
          <div className="text-lg font-semibold">Are you sure?</div>
          <div className="flex flex-col gap-3">
            <div className="text-md font-extrathin text-quaternary">
              You have made edits to the current run but they have not been
              added to a dataset. These changes won't be saved if you continue.
            </div>
            <div className="flex items-center gap-3">
              <Checkbox
                checked={isDontShowAgainChecked}
                onChange={() => setIsDontShowAgainChecked((prev) => !prev)}
              />
              <div className="text-disabled">Don't show this message again</div>
            </div>
          </div>
          <div className="flex gap-4 self-end">
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                isConfirmationModalOpen?.();
                setIsConfirmationModalOpen(null);
                if (isDontShowAgainChecked) {
                  setDontShowConfirmationAgain(true);
                }
              }}
            >
              Continue
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setIsConfirmationModalOpen(null);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </ModalDialog>
    </Modal>
  );
};
